import moment from 'moment';

export const statusOptions = {
    'pending': 'Pendente',
    'done': 'Concluído',
    'canceled': 'Sem sucesso',
};

// Business day utilities for cadence date management
export const isWeekend = (date) => {
    const dayOfWeek = date.day();
    return dayOfWeek === 0 || dayOfWeek === 6; // Sunday = 0, Saturday = 6
};

export const getNextBusinessDay = (date) => {
    let nextDay = date.clone();
    const originalDate = date.clone();
    
    while (isWeekend(nextDay)) {
        nextDay = nextDay.add(1, 'day');
    }
    
    return {
        date: nextDay,
        wasAdjusted: !originalDate.isSame(nextDay, 'day'),
        originalDate: originalDate,
        adjustmentReason: isWeekend(originalDate) ? 'weekend' : null
    };
};

export const addBusinessDays = (date, days) => {
    let currentDate = date.clone();
    let addedDays = 0;
    
    while (addedDays < days) {
        currentDate = currentDate.add(1, 'day');
        
        if (!isWeekend(currentDate)) {
            addedDays++;
        }
    }
    
    return currentDate;
};

export const calculateBusinessDaysBetween = (startDate, endDate) => {
    let businessDays = 0;
    let currentDate = startDate.clone();
    
    while (currentDate.isBefore(endDate, 'day')) {
        currentDate = currentDate.add(1, 'day');
        
        if (!isWeekend(currentDate)) {
            businessDays++;
        }
    }
    
    return businessDays;
};

export const adjustCadenceDates = (cadenceData, performedDate, taskIndex) => {
    if (!cadenceData || !cadenceData.data || taskIndex >= cadenceData.data.length) {
        return {
            cadenceData,
            adjustmentInfo: null
        };
    }
    
    const updatedData = [...cadenceData.data];
    const performedTask = updatedData[taskIndex];
    const originalDate = moment(performedTask.date, 'DD/MM/YYYY');
    const actualPerformedDate = moment(performedDate);
    
    // Calculate the delay in business days
    const delayInBusinessDays = calculateBusinessDaysBetween(originalDate, actualPerformedDate);
    
    const adjustmentInfo = {
        wasAdjusted: delayInBusinessDays > 0,
        delayInBusinessDays: delayInBusinessDays,
        adjustedTasks: [],
        originalDate: originalDate.format('DD/MM/YYYY'),
        performedDate: actualPerformedDate.format('DD/MM/YYYY')
    };
    
    // If task was performed late, adjust subsequent tasks
    if (delayInBusinessDays > 0) {
        for (let i = taskIndex + 1; i < updatedData.length; i++) {
            const currentTaskDate = moment(updatedData[i].date, 'DD/MM/YYYY');
            const originalTaskDate = currentTaskDate.format('DD/MM/YYYY');
            const adjustedDate = addBusinessDays(currentTaskDate, delayInBusinessDays);
            const newTaskDate = adjustedDate.format('DD/MM/YYYY');
            
            updatedData[i].date = newTaskDate;
            
            adjustmentInfo.adjustedTasks.push({
                taskIndex: i,
                originalDate: originalTaskDate,
                newDate: newTaskDate,
                taskType: updatedData[i].type
            });
        }
    }
    
    return {
        cadenceData: {
            ...cadenceData,
            data: updatedData
        },
        adjustmentInfo
    };
};

export const generateCadenceWithBusinessDays = (startDate, tasks, dayGaps) => {
    const businessStartResult = getNextBusinessDay(moment(startDate));
    const cadenceData = [];
    
    let currentDate = businessStartResult.date.clone();
    
    tasks.forEach((task, index) => {
        // For the first task, use the start date
        if (index === 0) {
            cadenceData.push({
                ...task,
                date: currentDate.format('DD/MM/YYYY'),
                uid: task.uid || `task_${index}_${Date.now()}`
            });
        } else {
            // Add the specified gap in business days
            const gap = dayGaps && dayGaps[index - 1] ? dayGaps[index - 1] : 1;
            currentDate = addBusinessDays(currentDate, gap);
            
            cadenceData.push({
                ...task,
                date: currentDate.format('DD/MM/YYYY'),
                uid: task.uid || `task_${index}_${Date.now()}`
            });
        }
    });
    
    return cadenceData;
};